import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { selectSelectedBusiness } from "selectors/ui";

export default function useBusinessUid() {
  const selectedBusiness = useSelector(selectSelectedBusiness);
  // return useSelector((state) => state.authedUser?.data?.businessUids?.[0]);
  return useParams().id ?? selectedBusiness;
}
